import { selectIsLoggedIn } from 'modules/common'
import { useAppSelector } from 'modules/core'
import { Navigate, Outlet } from 'react-router-dom'
import { useRedirectUrl } from './hooks'

export const AuthLayout = () => {
  const isLoggedIn = useAppSelector(selectIsLoggedIn)
  const { redirectUrl } = useRedirectUrl()

  if (!isLoggedIn) {
    return <Navigate to={`/login?redirectUrl=${redirectUrl}`} replace />
  }

  return <Outlet />
}
